import { addToast, Button, Icon, Modal } from '@octano/global-ui';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Container } from 'reactstrap';
import { removeTutors } from '../api';
import { useSharedData } from '../hooks/useSharedData';
import { useTexts } from '../hooks/useTexts';

interface Props {
  onConfirm: (teacherId: number) => void;
  onDecline?: () => void;
}

export interface ConfirmModalRef {
  openModal: (teacherId: number) => void;
  closeModal: () => void;
}

const ConfirmModal = forwardRef<ConfirmModalRef, Props>(
  ({ onConfirm, onDecline }, ref) => {
    const texts = useTexts();
    const { unassigned, updateData } = useSharedData();

    const [loading, setLoading] = useState(false);
    const [teacherId, setTeacherId] = useState<number>();
    const [modal, setModal] = useState(false);

    useImperativeHandle(ref, () => ({
      openModal(teacherId: number) {
        setTeacherId(teacherId);
        setModal(true);
      },
      closeModal() {
        setModal(false);
      },
    }));

    const onSubmit = async () => {
      setLoading(true);
      const dataForm = {
        studyPlanEnrollmentIds: unassigned ?? [],
      };

      if (dataForm.studyPlanEnrollmentIds && teacherId) {
        const { data, error } = await removeTutors(teacherId, dataForm);
        if (data && error === false) {
          addToast({
            icon: 'success',
            color: 'success',
            text: texts.confirmModal.saveSuccess,
          });
        } else if (error) {
          addToast({
            color: 'danger',
            icon: 'error',
            text: texts.confirmModal.saveError,
          });
        }
      }

      updateData({ unassigned: [] });
      onConfirm(teacherId!);
      setLoading(false);
      setModal(false);
    };

    return (
      <Modal isOpen={modal} toggle={() => setModal(!modal)}>
        <Container fluid className="text-center">
          <Icon name="information" size={45} />
          <h1 className="text-dark fs-20 mt-3 mb-4">
            {texts.confirmModal.title}
          </h1>

          <div className="d-flex justify-content-around" style={{ gap: 10 }}>
            <Button
              outlined
              disabled={loading}
              className="w-100"
              text={texts.confirmModal.actions.cancel}
              onClick={() => {
                onDecline && onDecline();
                setModal(false);
              }}
            />
            <Button
              loading={loading}
              disabled={loading}
              className="w-100"
              text={texts.confirmModal.actions.confirm}
              onClick={() => {
                onSubmit();
              }}
            />
          </div>
        </Container>
      </Modal>
    );
  },
);

export default ConfirmModal;
